module.exports = commonObj;